module.exports = "/_next/static/images/mobile_hero_en-b04e5468c085d5961e11adce79b6c8af.webp";